import type { IUpdateStoreRequest } from '@/common/interfaces/store.interface';

export interface IStoreOrderItemSizesUpdateInput {
  id: number;
  order_item_id: string;
  sizes: string;
  allowed_sizes: string;
}

export const buildStoreOrderItemSizesUpdatePayload = (
  orderId: number,
  orderItem: IStoreOrderItemSizesUpdateInput
): IUpdateStoreRequest => ({
  order_id: orderId,
  order_items: [orderItem],
});
